export enum WorkflowIntakeFormType {
  Company = 'company',
  CompanyAndCounterparty = 'company_or_counter',
  Counterparty = 'counter',
}
